export default __webpack_public_path__ + "c8f7d99.png";